var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modoul" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.setting.title,
            visible: _vm.setting.visible,
            width: "600",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.setting, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formModal",
                  attrs: {
                    model: _vm.formModal,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "菜单名称", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入菜单名称" },
                        model: {
                          value: _vm.formModal.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "name", $$v)
                          },
                          expression: "formModal.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "父菜单路由", prop: "parentId" } },
                    [
                      _c(
                        "el-select",
                        {
                          ref: "parentMenu",
                          attrs: { placeholder: "请选择父菜单路由" },
                          on: { change: _vm.handleParentType },
                          model: {
                            value: _vm.formModal.parentId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "parentId", $$v)
                            },
                            expression: "formModal.parentId",
                          },
                        },
                        _vm._l(_vm.parentType, function (item) {
                          return _c("el-option", {
                            key: item.menuId,
                            attrs: { label: item.name, value: item.menuId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "路由名称", prop: "url" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入路由名称" },
                        model: {
                          value: _vm.formModal.routeName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "routeName", $$v)
                          },
                          expression: "formModal.routeName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "路由地址", prop: "url" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入路由地址" },
                        model: {
                          value: _vm.formModal.url,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "url", $$v)
                          },
                          expression: "formModal.url",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "icon图标", prop: "url" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入icon图标" },
                        model: {
                          value: _vm.formModal.icon,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "icon", $$v)
                          },
                          expression: "formModal.icon",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "权限标识", prop: "url" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入权限标识" },
                        model: {
                          value: _vm.formModal.perms,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "perms", $$v)
                          },
                          expression: "formModal.perms",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "菜单类型", prop: "type" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择父菜单路由" },
                          model: {
                            value: _vm.formModal.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "type", $$v)
                            },
                            expression: "formModal.type",
                          },
                        },
                        _vm._l(_vm.menuType, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: {
                              label: item.label,
                              value: item.value,
                              disabled: item.disabled,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.setting.visible = false
                      _vm.$refs.formModal.resetFields()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.settingEvent } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }